import { createAction } from 'redux-actions';

export const RESET_FOR_REINIT = 'CLIENT.RESET_FOR_REINIT';
export const resetForReinit = createAction(RESET_FOR_REINIT);
